<template>
  <div class="atb-full-height export-task atb-content-bg atb-flex atb-flex-column">
    <common-datagrid ref="exportTaskDatagrid" ID="exportTaskIndex" :columns="columns" :url="$api.manage.exportTask.list" :params="search"
    :remoteMethod='requestMethod' :filterData="filterData" :filterTotal="filterTotal" border="inner" size="medium" 
    :pagination="false" :paramsReset="paramsReset">
      <template slot="searchForm">
        <el-form class="atb-input" :inline="true" 
        v-on:keyup.enter.native.prevent="loadData(1)" @submit.native.prevent>
          <!-- <el-form-item label="操作人">
            <el-input v-model="search.ResWkName" placeholder="操作人" clearable></el-input>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="loadData(1)">刷新</el-button>
          </el-form-item>
        </el-form>
      </template>
      <template v-slot:option="{ row }">
        <el-tooltip v-if="row.downloadAddress && !noDownloadTypes.includes(row.exportType)" class='item' effect='dark' content='下载' placement="bottom">
          <i class='el-icon-download' @click.stop='download(row)'></i>
        </el-tooltip>
      </template>
      <template v-slot:date="{ row,column }">
        {{(row[column.field] && new Date(row[column.field]) || '') | formatDate('yyyy-MM-dd hh:mm:ss')}}
      </template>
      <template v-slot:no="{ rowIndex }">
        <div class="vxe-cell">{{(rowIndex+1) + (handledPage.PageIndex-1) * handledPage.PageSize}}</div>
      </template>
      <template v-slot:status="{ row,column }">
        {{ Status[row[column.field]] }}
      </template>
      <template v-slot:exportType="{ row,column }">
        {{ ExportType[row[column.field]] }}
       </template>
    </common-datagrid>
    <div class='page-con atb-flex atb-flex-justify-end'>
        <vxe-pager
          background
          :current-page.sync="handledPage.PageIndex"
          :page-size.sync="handledPage.PageSize"
          :total="handledTotal"
          height="100%"
          @page-change="handledPageChange"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Total']"
        >
        </vxe-pager>
    </div>
    <common-dialog ref="commonDialog" :title="dialogContent.title" width="700px" :showClose="true">
      <template slot="content">
        <component v-bind:is="dialogContent.componentName" :editData="EditRow" @submitSuccess="loadData"></component>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import tableMixin from '@/mixins/table.mixin'
export default {
  mixins: [ tableMixin ],
  data() {
    return {
      id: 'id',
      columns: [
        { title: "序号", type: "no", width: "50", align: "center", fixed: "left",slot:'no' },
        { title: "任务下载", field: "option", width: "100", align: "center", fixed: "right", slot: 'option' },
        { title: "任务名称", field: "summary", width: "120"},    
        { title: "导出状态", field: "status", width: "100",slot:'status'},  
        { title: "导出类型", field: "exportType", width: "100",slot:'exportType'},  
        { title: "部门名称", field: "department" , width: "220"},
        { title: "操作人", field: "resWkName", width: "80"},
        { title: "导出时间", field: "exportTime", width: "165", slot: "date" },
        { title: "导出说明", field: "reason", width: "160" },
      ],
      requestMethod:'get',
       handledPage: {
        PageIndex: 1,
        PageSize: 10
      },
      handledTotal: 0,
      Status: {
          0: '未开始',
          1: '进行中',
          2: '导出完成',
          3: '导出失败',
      },
      ExportType: {
          0: '其它',
          1: '日清',
          2: '周清',
          3: '月清',
          4: '年清',
          5: '管理人员',
          6: '综合绩效管理',
          7: '综合考核评分',
          8: '综合绩效查询',
          9: '综合绩效管理批量',
          10: '重要度排序管理',
          12: '周报表统计',
          13: '日报表统计',
          14: '综合绩效管理导出',
          15: '综合绩效信息公示',
          16: '岗位职责查询-导出',
          20: '申报提醒',
          21: '审批提醒',
          22: 'OEC建议申报提醒',
          24: 'OEC建议申报查询批量导出',
          25: 'OEC建议管理批量导出',
          30: '岗位职责申报提醒',
          31: '岗位职责审批提醒',
          32: '岗位职责管理-批量导出状态',
          33: '岗位职责管理-批量导出表格',
          34: 'OEC建议结果推送',
          40: '部门配置提醒导出',
          41: '部门配置提醒消息导出',
          45: '直属下级未执行表格导出',
          46: '直属下级未完成半年总结导出',
          50: '综合结果提交提醒',
          51: '综合结果审批提醒',
          52: '考核表提交提醒',
          53: '考核表确认提醒',
          60: '重要度提交提醒',
          61: '重要度审批提醒',
          70: '年工作项提交发布',
          71: '新增工作项提交发布',
      },
      noDownloadTypes: [20, 21, 22, 30, 31, 34, 50, 51, 52, 53, 60, 61, 70, 71],
    }
  },
  methods: {
    loadData(page) {
      this.handledPage.PageIndex=page;
      this.$refs.exportTaskDatagrid.loadData(page)
    },
    filterData(data){
      return data.rows;
    },
    filterTotal(data){
      this.handledTotal=data.data&&data.data.total;
      return data.data&&data.data.total||0;
    },
    handledPageChange({ currentPage }) {
      this.handledPage.PageIndex=currentPage;
      this.loadData(currentPage);
    },
    download(row){
        const file = row.downloadAddress? row.downloadAddress.split('/').pop(): '';
        const filename=file.split('.')[0];
        const filetype=file.split('.')[1];
        const url = this.$config.baseUrl + row.downloadAddress;
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.href = url;
        a.download = filename + '.' + filetype;
        a.click();
        window.URL.revokeObjectURL(url);
    },
    paramsReset(){
      return { ResWkName: this.search.ResWkName, PageIndex: this.handledPage.PageIndex, PageSize: this.handledPage.PageSize };
    },
  }
}
</script>
<style scoped lang='scss'>
.export-task {
  ::v-deep .link-ele{
    margin: 0 5px;
  }
 ::v-deep .atb-datagrid-card {
    flex: 1;
    overflow: auto;
  }
  ::v-deep .vxe-table--render-default.size--medium .vxe-header--column:not(.col--ellipsis){
    padding: 12px 0;
  }
  ::v-deep .vxe-table--render-default.vxe-editable.size--medium .vxe-body--column{
    height: 48px;
  }
  ::v-deep .vxe-table--render-default.size--medium .vxe-header--column.col--ellipsis{
    height: 48px;
  }
  .vxe-body--column.col--last i {
    font-size: 20px;
    color: #22b6a1;
    margin-right: 16px;
    cursor: pointer;
  }
  .vxe-body--column.col--last i.delete {
      color: #fe6562;
  }
}
</style>
